import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/instructions')({
    component: () => (
        <section className="max-w-md mx-auto">
            <Outlet />
        </section>
    ),
});
